/**
 * Result shape of `useCoachingPreferences`.
 *
 * Mirrors the three controls in the legacy Queue "Coaching Settings" drawer:
 * realtime coaching toggle, auto-suggestions toggle, and the AI agent template
 * dropdown. Realtime + auto-suggestions persist via `useUserPreferencesMutation`
 * (server-side `coffeePreferences`); the template selection persists via
 * localStorage in this PR — wiring it back to the focused-view coaching
 * pipeline is a follow-up.
 *
 * **Single-consumer constraint.** `selectedCoachingTemplateId` is held in local
 * `useState` initialized from `localStorage`. The hook does not listen for
 * cross-tab `storage` events or expose a same-tab broadcast, so two
 * simultaneously-mounted consumers (e.g. SettingsPanel + a future coaching
 * pipeline reader) will desync until one remounts. The Stage-3 SettingsPanel is
 * the only consumer; lift this to a shared store (zustand) when wiring the
 * pipeline follow-up.
 */
export type UseCoachingPreferencesResult = {
	realtimeCoachingEnabled: boolean;
	autoSuggestionsEnabled: boolean;
	selectedCoachingTemplateId: string | null;
	setRealtimeCoaching: (enabled: boolean) => Promise<void>;
	setAutoSuggestions: (enabled: boolean) => Promise<void>;
	setCoachingTemplate: (id: string | null) => void;
	isMutating: boolean;
};

export const COACHING_TEMPLATE_LS_KEY = 'focused-view:coaching-template-id';
